import isProduction from './isProduction';

export const Feature = Object.freeze({
  GMAIL_CONNECTION: 'GMAIL_CONNECTION',
  PROJECT_CHAT: 'PROJECT_CHAT',
  PROJECT_EMAIL: 'PROJECT_EMAIL',
  VIDEO_CHAT: 'VIDEO_CHAT',
  INVOICE_PAYMENT: 'INVOICE_PAYMENT',
});

const BusinessId = Object.freeze({
  LIXANI: '2624244-6',
  PAASO_CAPITAL: '3223682-7',
  AIRLOUNGE: '3586419-1',
  ESJP: '0977134-6',
  TEST: '123',
});

const USUAL_SUSPECTS = [
  BusinessId.LIXANI,
  BusinessId.PAASO_CAPITAL,
  BusinessId.AIRLOUNGE,
  BusinessId.ESJP,
  BusinessId.TEST,
];

const checkUsualSuspects = (project) => {
  return project && USUAL_SUSPECTS.includes(project.business_id);
};

const isFeatureEnabled = (featureName, project) => {
  try {
    switch (featureName) {
      case Feature.GMAIL_CONNECTION: // Disabled for all projects, for time being
        return false;
      case Feature.PROJECT_CHAT: // Disable for employer projects
        return project && project.type !== 'EMPLOYER';
      case Feature.VIDEO_CHAT: // Check if project chat is enabled
        return isFeatureEnabled(Feature.PROJECT_CHAT, project);
      case Feature.PROJECT_EMAIL:
      case Feature.INVOICE_PAYMENT: // Enabled only for specific business IDs, or in non-production environments
        return checkUsualSuspects(project) || !isProduction;
      default:
        console.warn(`Feature flag for ${featureName} is not defined.`);
        return false;
    }
  } catch (error) {
    console.error(`Error checking feature flag for ${featureName}:`, error);
    return false; // Default to false if there's an error
  }
};

export default isFeatureEnabled;
